import { cloneDeep } from 'lodash'

export function sortProfessionals (professionals) {
  let profissionais = []
  professionals.map(item => {
      profissionais.push({
        'nome': item.doctorName,
        'crm': item.registrationCode,
        'id': item.resourceLid,
        'notice': item.notice
    })
  });
  return profissionais.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
